import React, { Component } from 'react';
import YoutubeResultView from './YoutubeResultView.js';
import { Badge, Label, Button, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import {setYoutubeSearchTerms} from 'actions/index.js';
import GenericSearcher from './GenericSearcher.js';
import axios from 'axios';
import { connect } from "react-redux";
import {getYoutubeTitle} from './getYoutubeTitle.js';
const apiKey = "AIzaSyCf2k8RM7tFFlVGo4CVPvCsOhx86vWwTT0";

const DISCOGS = 'DISCOGS';
const YOUTUBE = 'YOUTUBE';

class YoutubeSearcher extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchResults: [],
            mode: YOUTUBE,
            nextPageToken: null,
            prevPageToken: null,
            next: false,
            previous: false,
            relatedMode: false,
            labelMode: false,
            inspirationalWords: [],
        };

        this.addListeners();
    }

    componentDidMount() {
        if (this.props.searchTerms !== '') {
            this.searchYoutube();
        }
    }

    searchYoutube(pageToken) {
        var self = this;
        var token = '';
        if (pageToken !== undefined) {
            token = '&pageToken=' + pageToken;
        } else {
            // clear the tokens
            this.state.nextPageToken = null;
            this.state.prevPageToken = null;
        }
        this.state.relatedMode = false;
        axios.get(
            'https://www.googleapis.com/youtube/v3/search?part=snippet&' + 
                'type=video&key=' + apiKey +
                '&maxResults=8&q=' + this.props.searchTerms + token)
            .then(function (ret) {
        
                if ('nextPageToken' in ret.data) {
                    self.state.nextPageToken = ret.data.nextPageToken;
                }
                if ('prevPageToken' in ret.data) {
                    self.state.prevPageToken = ret.data.prevPageToken;
                }
                var results = ret.data.items.map((item) => new YoutubeResult(item.id.videoId, item.snippet.title));
                self.state.searchResults = results;
                self.setState(self.state);
            });
    }

    clearResults() {
        this.state.nextPageToken = null;
        this.state.prevPageToken = null;
        this.props.setYoutubeSearchTerms('');
        this.state.searchResults = [];
        this.setState(this.state);
    }

    onKeyPress(e) {
        if (e.key === 'Enter') {
            this.searchYoutube();
        }
    }

    addListeners() {
        window.addEventListener('get_related_videos', () => {
            this.getRelatedResults();
        });
    }

    getRelatedResults(pageToken) {
        var self=this;
        this.state.relatedMode = true;
        var token = '';
        if (pageToken !== undefined) {
            token = '&pageToken=' + pageToken;
        } else {
            // clear the tokens
            this.state.nextPageToken = null;
            this.state.prevPageToken = null;
        }
        
        axios.get(
            'https://www.googleapis.com/youtube/v3/search?part=snippet&' + 
                'relatedToVideoId=' + this.props.videoId + '&' + 
                'type=video&key=' + apiKey +
                '&maxResults=8' + token)
            .then(function (ret) {
                if ('nextPageToken' in ret.data) {
                    self.state.nextPageToken = ret.data.nextPageToken;
                }
                
                if ('prevPageToken' in ret.data) {
                    self.state.prevPageToken = ret.data.prevPageToken;
                }
                
                var results = ret.data.items.map((item) => new YoutubeResult(item.id.videoId, item.snippet.title));
                self.state.searchResults = results;
                self.setState(self.state);
                });
    }

    onClickInspired() {
        let tags = this.ethereumCache.index.TAG.TAG;

        let tag = tags[Math.floor(Math.random() * tags.length)];
        this.setState({inspirationalWords: tag.values});
    }

    render() {
        return (
            <div className="youtube-search-container">
              <GenericSearcher
                placeHolder="Search youtube"
                onChange={this.props.setYoutubeSearchTerms}
                searchTerms={this.props.searchTerms}
                onSearch={() => this.searchYoutube()}/>
              <div className="pagination-pane">
              {this.state.prevPageToken ?
                  <div onClick={() => {this.state.relatedMode ? 
                                       this.getRelatedResults(this.state.prevPageToken) :
                                       this.searchYoutube(this.state.prevPageToken)}}
                     className='field-pagination-button'>Previous</div> : ''}
              {this.state.nextPageToken ?
                    <div onClick={() => {this.state.relatedMode ? 
                                         this.getRelatedResults(this.state.nextPageToken) :
                                         this.searchYoutube(this.state.nextPageToken)}}
                     className='field-pagination-button'>Next</div> : ''}
              <div onClick={() => this.clearResults()} className="field-pagination-button">Clear</div>
              </div>
              {this.state.searchResults.map((result) =>
                  <YoutubeResultView onClick={() => this.props.onClickResult(result)} result={result}/>)}
            </div>
        );
    }
}

class YoutubeResult {
    constructor(videoId, title) {
        this.videoId = videoId;
        this.title = title;
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setYoutubeSearchTerms: s => dispatch(setYoutubeSearchTerms(s)),
    };
};

const mapStateToProps = state => {
    return {
        searchTerms: state.discover.youtubeSearchTerms
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(YoutubeSearcher);
